import unhead_KgADcZ0jPj from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/builds/david.s/LocalinoHubItemSpotter/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/david.s/LocalinoHubItemSpotter/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_Jozdw60ZsE from "/builds/david.s/LocalinoHubItemSpotter/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/builds/david.s/LocalinoHubItemSpotter/.nuxt/pwa-icons-plugin.ts";
import cookies_plugin_6rodMcqu28 from "/builds/david.s/LocalinoHubItemSpotter/src/plugins/cookies.plugin.ts";
import form_plugin_osd0LcgVc1 from "/builds/david.s/LocalinoHubItemSpotter/src/plugins/form.plugin.ts";
import pwa_client_03FA6liQIe from "/builds/david.s/LocalinoHubItemSpotter/src/plugins/pwa.client.ts";
import pwa_plugin_5TbVodmYD6 from "/builds/david.s/LocalinoHubItemSpotter/src/plugins/pwa.plugin.ts";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_Jozdw60ZsE,
  pwa_icons_plugin_LnrhIJeMG7,
  cookies_plugin_6rodMcqu28,
  form_plugin_osd0LcgVc1,
  pwa_client_03FA6liQIe,
  pwa_plugin_5TbVodmYD6
]